<template>
	<div class="course-upload">
		<h3 class="mb-4 font-weight-bold">Upload Course</h3>
		<form class="upload-form border p-3">
			<h5>Thumbnail</h5>
			<div class="form-row">
				<div class="col form-group m-0">
					<!-- Sementara masukin url aja -->

					<!-- <input class="d-block" type="file" name="thumbnail" placeholder="URL" @change="onFilePicked"> -->

					<input type="file" class="d-none" ref="upload" @change="sendImage">
					<div 
						style="cursor: pointer;" 
						class="bg-light justify-content-center align-items-center d-flex border h-100"
						v-on:click="choose"
						type="file"
						>
						<h5 class="text-center" v-if="!show">add a thumbnail</h5>
						<img class="w-100" v-bind:src="images" v-if="show">

					</div>

				</div>
				<div class="col border p-3">
					<div class="form-group">
						<label>Title</label>
						<input type="text" class="form-control" v-model="title">
					</div>
					<div class="form-group">
						<label>Sub-Title</label>
						<input type="text" class="form-control" v-model="subtitle">
					</div>
					<div class="form-group m-0">
						<label>Description</label>
						<textarea class="form-control" v-model="description"></textarea>
					</div>
				</div>
			</div>

			<br>

			<!-- BACKGROUND -->
			<div class="form-group mt-3">
				<label>Background</label>
				
				<!-- Sementara masukin url aja -->
				<!-- <input class="form-control mb-2" type="text" name="background" v-model="background" placeholder="URL">
 -->

				<div class="input-group mb-2">
					<div class="custom-file">
						<input type="file" class="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" @change="sendBackground">
						<label class="custom-file-label" for="inputGroupFile01">Choose file</label>
					</div>
				</div>

				<textarea class="form-control" rows="3" placeholder="Background Description" v-model="background_desc"></textarea>
			</div>

			<!-- INSTRUCTORS -->
			<div class="form-group">
				<label>Instructor(s)</label>

				<!-- INI YANG NULIS MANUAL -->
				<!-- <input type="text" class="form-control mb-2" v-model="inputedInstructor" ref="input_instructor">
				{{inputedInstructor}}
				<p class="text-right">
					<button class="btn" v-on:click="addInstructor()" type="button">&plus;</button>
				</p> -->

				<p><button class="btn btn-sm" disabled v-for="(instructor, i) in selectedInstructors" :key="i">{{instructor}}</button></p>

				<select class="form-control mb-2" v-model="instructor">
					<option v-for="(instructor, i) in instructorsFromDatabase" :value="instructor" :key="i">{{instructor.name}}</option>
				</select>
				<p class="text-right">
					<button class="btn" type="button" @click="addInstructor()">add</button>
				</p>
			</div>

			<!-- CATEGORIES -->
			<h6>*Silahkan klik add setelah memilih category, subcategory dan topic</h6>
			<div class="d-block d-lg-flex border p-2">
				<div class="col-lg-4 form-group m-0">
					<label class="m-0">Categories</label>
					<p class="d-block"><button class="btn btn-sm d-block mb-1" disabled v-for="(category, i) in selectedCategories" :key="i">{{category}}</button></p>
					<select class="form-control mb-2" v-model="category">
						<option v-for="(category, i) in categoriesFromDatabase" :value="category" :key="i">{{category.name}}</option>
					</select>

					<p class="text-right m-0">
						<button class="btn" type="button" @click="addCategory()">add</button>
					</p>

				</div>
				<br>
				<div class="col-lg-4 form-group m-0" v-show="showSubtitle">
					<label class="m-0">Sub category</label>
					<p class="d-block"><button class="btn btn-sm d-block mb-1" disabled v-for="(sub, i) in subs" :key="i">{{sub}}</button></p>
					<select class="form-control mb-2" v-model="subCategory">
						<option v-for="(sub, i) in dataSubFix" :key="i">{{sub.name}}</option>
					</select>

					<p class="text-right m-0">
						<button class="btn" type="button" @click="addSubcategory(subCategory)">add</button>
					</p>
				</div>
				<br>
				<div class="col-lg-4 form-group m-0" v-show="showTopic">
					<label class="m-0">Topic</label>
					<p class="d-block"><button class="btn btn-sm d-block mb-1" disabled v-for="(top, i) in selectedTopic" :key="i">{{top}}</button></p>
					<select class="form-control mb-2" v-model="topic">
						<option v-for="topic in dataTopic" :key="topic">{{topic}}</option>
					</select>
					<p class="text-right">
						<button class="btn" type="button" @click="addTopic(topic)">add</button>
					</p>
				</div>	
				
			</div>

			<br>

			<!-- SECTIONS -->
			<div class="form-group">
				<label>Section(s)</label>

				<!-- INI YANG SELECT LIST -->
				<!-- <p><button class="btn btn-sm" disabled v-for="(section, i) in selectedSections" :key="i">{{section}}</button></p>
				<select class="form-control mb-2" v-model="section">
					<option v-for="(section, i) in sectionsFromDatabase" :value="section" :key="i">{{section.title}}</option>
				</select>
				<p class="text-right">
					<button class="btn" type="button" @click="addSection()">add</button>
				</p> -->

				<p><button class="btn btn-sm" disabled v-for="(section, i) in sections" :key="i">{{section.title}}</button></p>

				<!-- INI YANG NULIS MANUAL -->
				<form class="form border p-3">
					<div class="form-group">
						<label>number</label>
						<input class="form-control" type="number" v-model="section_number">
					</div>
					<div class="form-group">
						<label>title</label>
						<input class="form-control" type="text" v-model="section_title">
					</div>
					<div class="form-group">
						<label>video</label>
						
						<!-- INI YANG SELECT LIST -->
						<!-- <select class="form-control" v-model="video">
							<option v-for="video in videos">{{video.title}}</option>
						</select> -->

						<p><button class="btn btn-sm" disabled v-for="(video, i) in videos" :key="i">{{video.title}}</button></p>

						<!-- INI YANG NULIS MANUAL -->
						<form class="form border p-3">
							<div class="form-group">
								<label>number</label>
								<input class="form-control" type="number" v-model="video_number">
							</div>
							<div class="form-group">
								<label>title</label>
								<input class="form-control" type="text" v-model="video_title">
							</div>
							<div class="form-group">
								<label>url</label>
								<input class="form-control" type="text" v-model="video_url">
							</div>
							<div class="form-group">
								<label>duration</label>
								<input class="form-control" type="text" v-model="video_duration">
							</div>
							<div class="form-group">
								<label>locked</label>
								<select class="form-control" v-model="video_locked">
									<option value="false">false</option>
									<option value="true">true</option>
								</select>
							</div>
							<div class="form-group text-right">
								<button type="button" class="btn" @click="addVideo()">add video</button>
							</div>
						</form>
					</div>
					<div class="form-group text-right">
						<button type="button" class="btn" @click="addSection()">add section</button>
					</div>
				</form>
			</div> <!-- SECTIONS end -->
			
			<!-- SUBMIT COURSE -->
			<p class="text-right">
				<button type="button" class="btn btn-primary rounded-0 font-weight-bold" @click="submit" v-if="!processing">SUBMIT</button>
				<button class="btn btn-warning rounded-0 font-weight-bold" disabled v-else>processing...</button>
			</p>
		</form>
	</div>
</template>

<script>

import axios from 'axios'
import App from '@/App'

export default {
	data() {
		return {
			url: App.data().url,
			processing: false,

			thumbnail: '',
			title: '',
			subtitle: '',
			description: '',
			
			instructor: '',
			instructors: [],
			selectedInstructors: [],
			inputedInstructor: '',

			category: '',
			categories: [],
			selectedCategories: [],

			section: '',
			sections: [],
			selectedSections: [],

			section_number: '',
			section_title: '',
			video: '',
			videos: [],

			video_title: '',
			video_number: '',
			video_url: '',
			video_duration: '',
			video_locked: true,

			background: '',
			background_desc: '',

			instructorsFromDatabase: [],
			categoriesFromDatabase: [],
			sectionsFromDatabase: [],
			
			subCategory: '',
			dataSub: [],
			dataSubFix: [],
			subs: [],

			topic: '',
			dataTopic: null,
			selectedTopic: [],

			images: '',
			background_images: '',
			show: false,
			showSubtitle: false,
			showTopic: false

		}
	},
	mounted(){
		App.methods.getData(this.url.instructors, (data)=>{
			if(data){
				this.instructorsFromDatabase = data;
			}
		});

		App.methods.getData(this.url.categories, (data)=>{
			if(data){
				this.categoriesFromDatabase = data;
			}
		});

		App.methods.getData(this.url.sections, (data)=>{
			if(data){
				this.sectionsFromDatabase = data;
			}
		});
	},
	methods: {
		choose() {
			this.$refs.upload.click();
			this.show = true;
		},
		submit(){
			var self = this;
			this.processing = true;

			var headers = {
				'x-access-token': localStorage.getItem('eclass-token')
			}

			let course_id = '';

			var data = {
				title: this.title,
				subtitle: this.subtitle,
				description: this.description,
				background: this.background_images,
				background_desc: this.background_desc,
				sections: [],
				instructors: this.instructors,
				categories: [{
					id_category: this.categories,
					name_category: this.selectedCategories,
					sub_category:[{
						id_sub: ID(),
						name_sub: this.subs,
						topic: [{
							id_topic: ID(),
							name_topic: this.selectedTopic
						}]
					}]
				}],
				thumbnail: this.images,
			}


			// POST COURSE
			axios.post(this.url.course, data, {headers: headers}).then((res) => {
				course_id = res.data.result;

				// postSections();
				postSectionsRecursion();
				
			})
			.catch((err) => {
				self.processing = false;
			})

			// ini data postSectionsRecursion
			var loop_count = 0;
			var sections_length = self.sections.length;
			let section_ids = [];
			function postSectionsRecursion(){
				if(loop_count < sections_length){
					var section = self.sections[loop_count];

					axios.post(
						self.url.section, 
						section,
						{headers: headers})
					.then((res) => {
						console.log('Berhasil post section ke:' + loop_count);
						// post dulu semua videonya supaya dapet array of video_id
						postVideos(section.videos, res.data.result, (video_ids)=>{

							// pasang course id nya
							section.course_id = course_id;

							// pasang video_ids ke section alias /put setiap sectionnya
							section.videos = video_ids;
							editSection(res.data.result, section, () => {
								checkLength(res.data.result);
							});
						});
					})
					.catch((err) => {
						self.processing = false;
					})
				}else{
					editCourse(section_ids);
				}

				function checkLength(id){
					section_ids.push(id);

					loop_count++;
					postSectionsRecursion();
				}
			}

			function editSection(section_id, section, callback){
				console.log('SECTION BROOO', section)
				axios.put(self.url.section + section_id, section, {headers: headers})
				.then((res) => {
					callback();
				})
				.catch((err) => {
					console.log(err)
				})
			}

			function editCourse(section_ids){
				axios.put(self.url.editcoursesections + course_id, {sections: section_ids}, {headers: headers})
				.then((res) => {					
					alert('POST COURSE BERHASIL!!!');
					window.location.reload();
				})
				.catch((err) => {
					console.log(err)
				})
				.then(()=>{
					self.processing = false;
				})
			}

			function postVideos(videos, section_id, callback){
				let len = videos.length;
				let count = 0;
				let ids = [];

				for (var i = 0; i < len; i++) {
					// pasang dulu id section dan id coursenya
					videos[i].section_id = section_id;
					videos[i].course_id = course_id;

					axios.post(
						self.url.video, 
						videos[i],
						{headers: headers})
					.then((res) => {
						count++;
						checkLength(res.data.result);
					})
					.catch((err) => {
						console.log(err)
					})
				}

				function checkLength(id){
					ids.push(id);

					if(count == len){
						callback(ids);
					}
				}
			}

			// *deprecated
			console.log('masuk ke pos section')
			function postSections(){
				console.log('Mencoba post sections...');
				
				let len = self.sections.length;
				let count = 0;
				let ids = [];

				for (var i = 0; i < self.sections.length; i++) {
					
					// pasang course id di setiap section
					self.sections[i].course_id = course_id;

					var section = self.sections[i];

					axios.post(
						self.url.section, 
						self.sections[i],
						{headers: headers})
					.then((res) => {

						// post dulu semua videonya supaya dapet array of video_id
						postVideos(section.videos, res.data.result, (video_ids)=>{

							// pasang video_ids ke section alias /put setiap sectionnya
							self.sections[i].videos = video_ids;
							editSection(res.data.result, self.sections[i], () => {
								count++;
								checkLength(res.data.result);
							});

						});
					})
					.catch((err) => {
						console.log(err)
					})
				}

				function checkLength(id){
					ids.push(id);

					if(count == len){
						// update course.sections dengan sections ids
						editCourse(ids);
					}
				}
			}

			function ID() {
				return '_' + Math.random().toString(36).substr(2, 9);
			}
		},
		sendBackground(event){
			var self = this;

			const background = event.target.files[0];
			let data = new FormData();
			data.append('file', background);

			let request = new XMLHttpRequest();
			request.open('POST', this.url.uploadimage);
			request.send(data);
			request.onreadystatechange = function () {
				if(request.readyState === 4 && request.status === 200) {
				var res = JSON.parse(request.responseText);
				self.background_images = res.url;
				}
			} 
		},
		sendImage(event) {
			this.show = true;
			let self = this;

			const image = event.target.files[0];

			let data = new FormData();
			data.append('file', image);

			let request = new XMLHttpRequest();
			request.open('POST', this.url.uploadimage);
			request.send(data);
			request.onreadystatechange = function () {
				if(request.readyState === 4 && request.status === 200) {
				var res = JSON.parse(request.responseText);
				this.show = true;
				self.images = res.url
				}
			}
		},
		postInstructors(callback){
			var len = this.instructors.length;
			var count = 0;
			var ids = [];
			
			var headers = {
				'x-access-token': localStorage.getItem('eclass-token')
			}

			for (var i = 0; i < this.instructors.length; i++) {
				axios.post(
					this.url.instructor, 
					{name: this.instructors[i]}, 
					{headers: headers})
				.then((res) => {
					count++;
					checkLength(res.data.result);
				})
				.catch((err) => {
					console.log(err)
				})
			}

			function checkLength(id){
				ids.push(id);

				if(count == len){
					console.log('selesai')
					callback(ids);
				}
			}
		},
		postVideo(callback){
			var len = this.instructors.length;
			var count = 0;
			var ids = [];

			var headers = {
				'x-access-token': localStorage.getItem('eclass-token')
			}

			for (var i = 0; i < this.videos.length; i++) {

				axios.post(
					this.url.video, 
					this.videos[i],
					{headers: headers})
				.then((res) => {
					count++;
					checkLength(res.data.result);
				})
				.catch((err) => {
					console.log(err)
				})
			}

			function checkLength(id){
				ids.push(id);

				if(count == len){
					callback(ids);
				}
			}
		},
		addInstructor(){
			var unique = true;
			for (var i = 0; i < this.instructors.length; i++) {
				if(this.instructors[i] == this.instructor.aid){
					unique = false;
				}
			}

			if(unique){
				this.instructors.push(this.instructor.aid);
				this.selectedInstructors.push(this.instructor.name);
			}

			// INI YANG NULIS MANUAL

			// var unique = true;
			// for (var i = 0; i < this.instructors.length; i++) {
			// 	if(this.instructors[i] == this.inputedInstructor){
			// 		unique = false;
			// 	}
			// }

			// if(unique){
			// 	this.instructors.push(this.inputedInstructor);
			// 	this.selectedInstructors.push(this.inputedInstructor);
			// }

			// console.log(this.inputedInstructor)
			// this.inputedInstructor = '';
			// this.$refs.input_instructor.focus();
		},
		addCategory(){
			var unique = true;
			for (var i = 0; i < this.categories.length; i++) {
				if(this.categories[i] == this.category.aid){
					unique = false;
				}
			}

			if(unique){
				this.categories.push(this.category.aid);
				this.selectedCategories.push(this.category.name);
				this.dataSub.push(this.category)

				this.dataSubFix = [];
				this.dataSub.map( data => {
					data.subs.map( subs => {
						this.dataSubFix.push(subs)
						this.showSubtitle = true
					})
				})
			}
		},
		addSubcategory(Subcategory) {
			this.dataSubFix.map( data => {
				if(Subcategory == data.name){
					this.dataTopic = data.topics
					this.subs.push(data.name)
					this.showTopic = true;
				}
			})
		},
		addTopic(topic){
			console.log("DATA", topic)
			this.dataTopic.map(e => {
				if(topic == e){
					this.selectedTopic.push(topic)
				}

			})
		},
		addSection(){
			// INI YANG SELECT LIST
			// console.log(this.section)
			// var unique = true;
			// for (var i = 0; i < this.sections.length; i++) {
			// 	if(this.sections[i] == this.section.aid){
			// 		unique = false;
			// 	}
			// }

			// if(unique){
			// 	this.sections.push(this.section.aid);
			// 	this.selectedSections.push(this.section.title);
			// }

			// INI YANG NULIS MANUAL
			var inputedData = {
				number: this.section_number,
				title: this.section_title,
				videos: this.videos,
				course_id: null
			}

			this.sections.push(inputedData)

			this.section_number = 0;
			this.section_title = '';
			this.videos = [];
		},
		addVideo(){
			var inputedData = {
				title: this.video_title,
				number: this.video_number,
				url: this.video_url,
				duration: this.video_duration,
				locked: this.video_locked,
				section_id: null,
				course_id: null
			}

			this.videos.push(inputedData);

			this.video_title = ''
			this.video_number = 0
			this.video_url = ''
			this.video_duration = ''
			this.video_locked = true
		}

	}
}

</script>
<style scoped>
	.upload-form label {
		font-weight: bold;
	}
</style>